import { KEY, Resource } from "shelving";
import { PRIVACY_FORM_SCHEMA, REGISTER_SCHEMA } from "shared/schema";

export const REGISTER_USER = new Resource("registerUser", REGISTER_SCHEMA, KEY);
export const EDIT_PRIVACY_SETTINGS = new Resource("editPrivacySettings", PRIVACY_FORM_SCHEMA);
